import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import ExportCarsPage from './pages/ExportCarsPage';
import OurHistoryPage from './pages/OurHistoryPage';
import SellLeasingCarPage from './pages/SellLeasingCarPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased selection:bg-[#76eeda]/30 selection:text-[#293e30]">
      {/* Scroll to top on route change */}
      <ScrollToTop />

      {/* Sticky Header */}
      <Header />

      {/* Main Content */}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/export-cars" element={<ExportCarsPage />} />
          <Route path="/vores-historie" element={<OurHistoryPage />} />
          <Route path="/saelg-din-bil" element={<SellLeasingCarPage />} />
          <Route path="/privatlivspolitik" element={<PrivacyPage />} />
          <Route path="/handelsbetingelser" element={<TermsPage />} />
        </Routes>
      </main>

      {/* Footer Section */}
      <Footer />
    </div>
  );
}

export default App;
